module.exports = __webpack_public_path__ + "img/QA Tester.9415977e.png";